(function(){

	'use strict';

	/**
	* Initializer
	* Checks is there is Instagram element and gets the data
	*/
	$('.channel-instagram').each(function() {

		var self = $(this);
		var account = $(this).data('account');
		var instragramEndpoint = 'https://www.instagram.com/' + account + '/';
		// For smaller screens get only 3 otherwise use the data attr
		var count = ( $(window).width() < 641 ) ? 3 : $(this).data('count');


		// Make the request
		$.get( instragramEndpoint )

		.done(function( data ) {

			// Get the JSON from the raw HTML
			const jsonObject = data.match(/<script type="text\/javascript">window\._sharedData = (.*)<\/script>/)[1].slice(0, -1);

			// Pass the data to the build function
			buildInstagramHtml( self, JSON.parse(jsonObject), count );
		})

		.fail(function() {

			// Something went wrong
			console.log( 'Request failed for account ' + account );
		});
	});


	/**
	* Builds the HTML output
	* @param {object} - Reference to the caller
	* @param {array} - The returned instagram nodes
	* @param {number} - The requested number of items
	*/
	function buildInstagramHtml( self, data, count ) {

		// Only get the required amount
		const imageNodes = data.entry_data.ProfilePage[0].graphql.user.edge_owner_to_timeline_media.edges.splice(0, count);

		// Loop over each item
		imageNodes.forEach((item, i) => {

			// Do some work
			var n = i + 1;
			var image = _.find(item.node.thumbnail_resources, { 'config_width': 480 });
			var caption = _.truncate(item.node.edge_media_to_caption.edges[0].node.text, {
				'length': 290,
				'separator': /,? +/
			});

			// Append to the appropriate item
			self.find('.card:nth-child('+ n +')').append(`
			<img src="${image.src}" alt="${item.node.accessibility_caption}" width="381" height="381" loading="lazy">
			<a href="https://www.instagram.com/p/${item.node.shortcode}" target="_blank">
				<div class="smp-card-social__item-info">
					<span><i class="fas fa-comment"></i>${kFormat(item.node.edge_media_to_comment.count)}</span>
					<span><i class="fas fa-heart"></i>${kFormat(item.node.edge_liked_by.count)}</span>
				</div>
				<p class="smp-card-social__item-caption">${caption}</p>
			</a>
			`);

		});
	}

	// Polyfill for Math.sign for IE11
	if (!Math.sign) {
		Math.sign = function(x) {
			// If x is NaN, the result is NaN.
			// If x is -0, the result is -0.
			// If x is +0, the result is +0.
			// If x is negative and not -0, the result is -1.
			// If x is positive and not +0, the result is +1.
			return ((x > 0) - (x < 0)) || +x;
			// A more aesthetic pseudo-representation:
			//
			// ( (x > 0) ? 1 : 0 )  // if x is positive, then positive one
			//          +           // else (because you can't be both - and +)
			// ( (x < 0) ? -1 : 0 ) // if x is negative, then negative one
			//         ||           // if x is 0, -0, or NaN, or not a number,
			//         +x           // then the result will be x, (or) if x is
			//                      // not a number, then x converts to number
		};
	}

	/**
	* Helper for the K formatting
	* @param {number} - A number to format
	* @return {string} - A formatted number
	*/
	function kFormat(num) {
		return Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k' : Math.sign(num)*Math.abs(num)
	}

}());
